import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import logger from 'redux-logger';

import createRootReducer from './reducers';

// Define history type
export const history = createBrowserHistory();

// Create root reducer with history
const combinedReducer = createRootReducer(history);

// Define RootState type
export type RootState = ReturnType<typeof combinedReducer>;

// Define AppDispatch type
export type AppDispatch = typeof store.dispatch;

// Only add logger in development
const middlewares = [routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
  // Also disable Redux DevTools in production for better performance
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;